
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestmoversnearby",
      function () {
        return require("private-next-pages/bestmoversnearby/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestmoversnearby"])
      });
    }
  